import { CostCenterPriceModel } from './../archive/cost-center-price.model';
import { StoreModel } from 'src/app/models/archive/store.model';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { RemissionModel } from './remission.model';
import { OrderModel } from '../preliminaries/order.model';

export class RemissionDetailModel {
  remissionDetailId: number = 0;
  remissionId: number = 0;
  remission: RemissionModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  storeId: number = 0;
  store: StoreModel | null = null;
  quantity: number = 0;
  detailText: string | null = null;
  orderDetailId: number | null = null;
  orderDetail: OrderModel | null = null;
  swUseHoursDays: boolean = false;
  hoursDays: number = 0;
  hourometer: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  costCenterPrice: CostCenterPriceModel | null = null;
}
